import { createAsyncThunk } from "@reduxjs/toolkit";
import { GET_SHOWS_LIST } from "./showTypes";
import { GET_SHOWS } from "../../api/apiRoutes";
import { get } from "../../api";

export const getShowsList = createAsyncThunk(
  GET_SHOWS_LIST,
  async (facilityIds: string) => await get(GET_SHOWS(facilityIds))
);
